import React from 'react';

// title: string; hint?: string; rows: [{ label, value, color }]
const MiniSplitCard = ({ title, hint, rows = [] }) => (
  <div className="bg-white rounded-xl border p-4" style={{ borderColor: '#eef1f6' }}>
    <h3 className="text-[13px] font-outfit font-bold text-slate-900">{title}</h3>
    {hint && <div className="text-[11px] text-slate-400 mb-2 font-jakarta">{hint}</div>}
    <div className="space-y-1.5 mt-1">
      {rows.map((r) => (
        <div key={r.label} className="flex items-center justify-between text-xs font-jakarta">
          <span className="flex items-center gap-2 text-slate-600">
            <span className="w-2.5 h-2.5 rounded-sm" style={{ background: r.color }} />{r.label}
          </span>
          <span className="font-semibold text-slate-900">{r.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default MiniSplitCard;
